(function($){
        $(document).ready(function(){
           var height=  $('body .counter-grid .col-wrapper > div').matchHeight();
        });
    $(window).on('load scroll',function() {
        setTimeout(function(){
            counterReady();
        },1600);
    });
    $(window).on('load scroll',function() {
        counterReady();
    });
    function counterReady() {
        $('.counter').each(function () {
            var th = $(this);
            var attdata = $(this).parents('.item').attr('data-val');
            if (th.parents('.wow').hasClass('undefined') && attdata == '1') {
                th.prop('Counter', 0).animate({
                    Counter: th.attr('data-count')
                }, {
                    duration: 2000,
                    easing: 'swing',
                    step: function (now) {
                        var str = th.attr('data-count');
                        var substr = str.split('.');
                        if(substr[1]>0){
                            var num = Math.fround(now);
                            th.text(num.toFixed(1));
                        }else{
                            th.text(Math.ceil(now));
                        }

                    }
                });
                $(this).parents('.item').attr('data-val', '0')
            }

        });
    }
})(jQuery);